import { render, staticRenderFns } from "./other-fee.vue?vue&type=template&id=2ea7d568&scoped=true&"
import script from "./other-fee.vue?vue&type=script&lang=js&"
export * from "./other-fee.vue?vue&type=script&lang=js&"
import style0 from "./other-fee.vue?vue&type=style&index=0&id=2ea7d568&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7d568",
  null
  
)

export default component.exports